import Page from '../../components/Page';
import React from 'react';
import {Card, CardBody, CardHeader, Col, Row, Button, Table} from 'reactstrap';
import {Link} from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import API from "../../resources/index";

class AuditorDetailPage extends React.Component {
    auditorResource = API.auditorResource;
    companyResource = API.companyResource;

    constructor() {
        super();
        this.state = {
            auditor: {},
            companies: [],
        }
    }

    getAuditor = () => {
        if (this.props.match.params && this.props.match.params.auditor_id) {
            this.auditorResource.fetch(this.props.match.params.auditor_id, {
                keys: {
                    expand: [
                        'auth',
                        'companies'
                    ]
                }
            })
                .then(response => {
                    if (response.status === 200) {
                        this.setState({auditor: response.data});
                        this.getCompanies();
                    }
                })
        }
    };

    getCompanies = () => {
        this.companyResource.query()
            .then(response => {
                if (response.status === 200) {
                    this.setState({companies: response.data});
                }
            });
    };

    addCompany = (company_id) => {
        this.auditorResource.addCompany({
            company_id: company_id,
            auditor_id: this.state.auditor.id
        })
            .then(response => {
                if (response.status === 200) {
                    this.getAuditor();
                }
            });
    };

    removeCompany = (company_id) => {
        this.auditorResource.removeCompany({
            company_id: company_id,
            auditor_id: this.state.auditor.id
        })
            .then(response => {
                if (response.status === 200) {
                    this.getAuditor();
                }
            });
    };

    async deleteUser(auditor) {
        if (window.confirm(`Tem certeza que deseja excluir o auditor "${auditor.name}" ?`)) {
            this.auditorResource.delete(auditor.id)
                .then(response => {
                    if (response.status === 204) {
                        this.props.history.push('/auditors');
                    }

                })
        }
    }

    handleAuditorHasCompanyButton = (company) => {
        let has = false;
        this.state.auditor.companies.map(auditorCompany => {
            if (auditorCompany.id === company.id)
                has = true;
        });

        return has ?
            <Button key={company.id}
                    onClick={() => this.removeCompany(company.id)}
                    color='danger' outline>Remover</Button> :
            <Button key={company.id}
                    onClick={() => this.addCompany(company.id)}
                    color='success' outline>Adicionar</Button>
    };

    componentDidMount() {
        this.getAuditor();
    }

    render() {
        const {auditor} = this.state;
        const {user} = this.props;

        return <Page
            title="Detalhe Auditor"
            breadcrumbs={[{name: 'Auditores', active: false}, {name: 'Detalhe Auditor', active: true}]}
            className="">
            <Row>
                <Col>
                    <Card className="mb-3">
                        <CardHeader>
                            <Link className='btn btn-outline-secondary mr-2'
                                  to={`/auditors`}>
                                Auditores
                            </Link>

                            <Link className='btn btn-outline-secondary mr-2'
                                  to={`/auditors/form/${auditor.id}`}>
                                Editar
                            </Link>

                            {(auditor && user) && (auditor.auth_id !== user.id) &&
                            <Button color="danger" onClick={() => this.deleteUser(auditor)}>Apagar</Button>}
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col>
                                    <p>Nome</p>
                                    <h4>{auditor.name}</h4>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <p>Email</p>
                                    <h4>{auditor.auth && auditor.auth.email}</h4>
                                </Col>
                                <Col>
                                    <p>Status</p>
                                    <h4>{auditor.is_activated ? 'Sim' : 'Não'}</h4>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <p>Criado em</p>
                                    <h4>{(new Date(auditor.created_at)).toLocaleDateString('pt-br')}</h4>
                                </Col>
                                <Col>
                                    <p>Atualizado em</p>
                                    <h4>{(new Date(auditor.updated_at)).toLocaleDateString('pt-br')}</h4>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            <Row>
                <Col>
                    <Card className="mb-3">
                        <CardHeader>
                            Empresas Vinculadas ao Auditor
                        </CardHeader>
                        <CardBody>
                            <Table responsive>
                                <thead>
                                <tr>
                                    <th>Empresa</th>
                                    <th>Ações</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.state.companies.map(company => {
                                    return <tr key={company.id}>
                                        <td>{company.social_name}</td>
                                        <td style={{width: 15 + '%', textAlign: 'center'}}>
                                            {this.handleAuditorHasCompanyButton(company)}
                                        </td>
                                    </tr>
                                })}

                                {!this.state.companies.length && <tr>
                                    <td colSpan={4} style={{textAlign: 'center'}}>Não há itens para exibição</td>
                                </tr>}
                                </tbody>
                            </Table>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Page>
    };
}

const mapStateToProps = state => {
    return {user: state.userReducer.user};
};

export default connect(mapStateToProps)(AuditorDetailPage);



// WEBPACK FOOTER //
// ./src/pages/auditor/AuditorDetailPage.js